module.exports = __webpack_public_path__ + "media/assets/svg/logos/chat-dots-1e3215e1f80cc1e8a5b7ad5cb0873466.svg";